export const blogEn = {
  // Blog page
  blogHeroTitle: "SheCan Stories",
  blogHeroSubtitle: "Real women. Real strength. Real stories.",
  latestArticles: "Latest Articles",
  readMore: "Read More",
  byAuthor: "By",
  
  // Categories
  empowerment: "Empowerment",
  career: "Career",
  wellness: "Wellness",
  relationships: "Relationships",
  personalGrowth: "Personal Growth",
  inspiration: "Inspiration",
  mothersWisdom: "Mother's Wisdom",
  grandmothersLetters: "Letters from Grandmothers"
};

export default blogEn;
